export default "__VITE_ASSET__DNy2WQya__"